import { DecimalPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
    name: 'isDecimalNumber',
    standalone: false
})
export class IsDecimalNumberPipe implements PipeTransform {
	transform(value) {
		let numberFilter=new DecimalPipe("en-US");
		if (value && value.toString().indexOf('.') >= 0) {
			return numberFilter.transform(value, '2');
		} else {
			return value;
		}
	}
}